import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const apiUrl2 = process.env.REACT_APP_ADMIN_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getcheckAPi = async (data) => {
  try {
    const response = await axios.get(apiUrl + `scan?transaction_id=` + data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getbasicDetAPi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `basicprofile`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getOrgLogoApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_org_image`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    const response = await axios
      .post(adminApiUrl + `user/image_update`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getOrgListApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_enrolled_orgs`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getSwitchAccountApi = async (id) => {
  try {
    const response = await axios.get(adminApiUrl + `switch_org/${id}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
